import React from "react"
import { View, Icon, Window, Text } from "react-ame-components"

export class IconExample extends React.Component {
  render() {
    return (
      <Window>
        <View padding="small">
          <Text
            fontWeight="bold"
            fontSize="medium">
            Icon
          </Text>
          <View
            aligin="row"
            marginTop="small">
            <Icon
              icon="ame-outline"
              colorIcon="red"
            />
            <Icon
              icon="ame-outline"
              colorIcon="primary-pure"
            />
            <Icon
              dataCy="icon-teste"
              icon="colapse"
              width="40px"
              height="40px"
            />
          </View>
        </View>
      </Window>
    )
  }
}
